import PropTypes from "prop-types";
import Webcam from "react-webcam";
import Input from "../common/Input";
import Select from "../common/Select";
import { titleOptionsNew } from "../../constants";
import { Link } from "react-router-dom";
import RadioButton from "../common/Radio_button";
import active_email from "../../svg/active-email.svg";
import disable_email from "../../svg/disable-email.svg";
import email_solid from "../../svg/email_solid.svg";
import active_phone from "../../svg/active-phone.svg";
import disable_phone from "../../svg/disable-phone.svg";
import phone_solid from "../../svg/phone_solid.svg";
import upload from "../../svg/upload-active.svg";
import camera from "../../svg/camera.svg";
import user_icon from "../../svg/user_solid.svg";
import ProfileModel from "../Modal/ProfileModel";
import FormModal from "../Modal/formModal";
import "./index.scss";
import { useSelector } from "react-redux";
function PersonalDetailsSection(props) {
  const {
    handleUploadImage,
    handleImageSubmit,
    hiddenFileInput,
    handleChangeRadioButton,
    profile,
    profileDetails,
    handleChange,
    openImageUpload,
    setOpenImageUpload,
    webcamRef,
    validationError = {},
    capture,
    webcamImage,
    openWebcam,
    setOpenWebcam,
    handleWebcam,
    uploadedImage,
    handleImageModalClose,
    phone,
    setWebcamImage,
    buttonBar,
    setOpenRemoveImage,
    openRemoveImage,
    handleRemoveImageSubmit,
    formError,
    journalsList = [],
  } = props;
  const userDetails = useSelector((state) => state?.ProfileReducer?.user);

  function onRetake() {
    setWebcamImage("");
  }

  const render = () => {
    if (webcamImage) {
      return (
        <span className="flex-fill text-center">
          <img
            src={webcamImage}
            alt="invalid img"
            className="user-img"
            onClick={() => handleWebcam()}
          />
        </span>
      );
    }
    return (
      <Webcam
        onClick={() => capture()}
        audio={false}
        ref={webcamRef}
        width="50%"
        screenshotFormat="image/jpeg"
      />
    );
  };
  const renderImage = () => {
    if (uploadedImage) {
      return "";
    }
    return (
      <span
        className="flex-fill"
        onClick={() => {
          setWebcamImage("");
          setOpenWebcam(true);
        }}
      >
        <Link to="#" className="link">
          <img src={camera} className="me-2" alt="camera" />
          Take Picture
        </Link>
      </span>
    );
  };
  const renderponeNumberclass = () => {
    if (profileDetails?.phoneNumber) {
      return "form-control active-input pointer_event_none  tel-pd";
    } else {
      return "form-control grey-input tel-pd";
    }
  };
  const checkTelClass = () => {
    if (profileDetails?.phoneNumber) {
      return "tel-active";
    }
    return "tel-disable";
  };

  const handleSelectChange = (value, type) => {
    props.handleSelectChange(value, type);
  };

  // Helper to split fullName into First/Last name for display
  const fullNameStr = profileDetails?.fullName || "";
  const nameParts = fullNameStr.trim().split(/\s+/);
  const firstNameVal = nameParts[0] || "";
  const lastNameVal = nameParts.slice(1).join(" ") || "";

  const handleNameChange = (e) => {
    const { name, value } = e.target;
    let newFullName = "";
    if (name === "firstName") {
      newFullName = value + (lastNameVal ? " " + lastNameVal : "");
    } else if (name === "lastName") {
      newFullName = (firstNameVal ? firstNameVal : "") + " " + value;
    }
    // Call the parent handleChange with a synthetic event to update fullName
    handleChange({
      target: {
        name: "fullName",
        value: newFullName
      }
    });
  };

  const journalNameOptions = (journalsList || [])
    .map((item) => {
      if (typeof item === "string") return item;
      return item?.journalName || item?.name || item?.journal_name || item?.title || "";
    })
    .filter(Boolean);

  return (
    <div className="pd-card-body">
      <div className="profile-upload-section mb-4">
        <div
          className={`profile-upload ${profile ? "has-image" : ""}`}
          onClick={() => setOpenImageUpload(profile ? false : true)}
        >
          {profile ? (
            <div
              className="profile-uploadImg"
              style={{ backgroundImage: `url('${profile}')` }}
            ></div>
          ) : (
            <i className="fa fa-camera"></i>
          )}
        </div>
        <div className="upload-text-info">
          <div className="d-flex align-items-center">
            <span className="upload-title" onClick={() => setOpenImageUpload(true)}>
              Upload Profile Picture
            </span>
          </div>
          <p className="upload-subtitle">
            A professional photo will help build confidence with your clients
          </p>
          {profile && (
            <div className="upload-actions mt-2">
              <span onClick={() => setOpenImageUpload(true)} className="action-btn">
                Update
              </span>
              <span className="divider">|</span>
              <span onClick={() => setOpenRemoveImage(true)} className="action-btn remove-btn">
                Remove
              </span>
            </div>
          )}
          {validationError.profile && (
            <div className="label-error mt-2">Please upload profile picture.</div>
          )}
        </div>
      </div>

      <div className="form-fields-grid row">
        {/* Row 1: Title, First Name, Last Name */}
        <div className="col-md-2 mb-4">
          <div className={`position-relative py-2 ${validationError.title ? "errored" : ""}`}>
            <Select
              selectedValue={profileDetails?.title}
              options={titleOptionsNew?.map((val) => val?.key)}
              optionValues={titleOptionsNew?.map((val) => val?.value)}
              labelClass=""
              label="Title"
              name="title"
              placeholder="Select"
              handleChange={(value) => handleSelectChange(value, "title")}
              required={true}
              isInvalid={validationError.title}
              mandatory={true}
            />
          </div>
        </div>

        <div className="col-md-5 mb-4">
          <div className={validationError.fullName ? "errored" : ""}>
            <Input
              name="firstName"
              className={firstNameVal ? "form-control active-input with_icon" : "form-control grey-input with_icon"}
              type="text"
              labelClass=""
              label="First Name"
              placeholder="First Name"
              preIconClass={user_icon}
              value={firstNameVal}
              handleChange={handleNameChange}
              mandatory={true}
              isInvalid={validationError.fullName}
              required
            />
          </div>
        </div>

        <div className="col-md-5 mb-4">
          <div className={validationError.fullName ? "errored" : ""}>
            <Input
              name="lastName"
              className={lastNameVal ? "form-control active-input with_icon" : "form-control grey-input with_icon"}
              type="text"
              labelClass=""
              label="Last Name"
              placeholder="Last Name"
              preIconClass={user_icon}
              value={lastNameVal}
              handleChange={handleNameChange}
              mandatory={true}
              isInvalid={validationError.fullName}
              required
            />
          </div>
        </div>

        {/* Row 2: Email ID, Mobile Number */}
        <div className="col-md-6 mb-4 fillDisable">
          {userDetails?.email ? (
            <Input
              type="email"
              name="email"
              isInvalid={validationError.email}
              className="form-control with_icon active-input pointer_event_none"
              preIconClass={email_solid}
              labelClass=""
              label="Email ID"
              placeholder="Email ID"
              value={profileDetails?.email}
              required
            />
          ) : (
            <Input
              type="email"
              name="email"
              isInvalid={validationError.email}
              className="form-control with_icon active-input"
              preIconClass={email_solid}
              labelClass=""
              label="Email ID"
              placeholder="Email ID"
              value={profileDetails?.email}
              handleChange={handleChange}
              required
            />
          )}
        </div>

        <div className="col-md-6 mb-4">
          {profileDetails.nationality !== "outSideIndia" && (
            <div className="position-relative fillDisable">
              <span className={checkTelClass()}>+91 |</span>
              <Input
                type="tel"
                name="phoneNumber"
                className={renderponeNumberclass()}
                preIconClass={phone_solid}
                labelClass=""
                label="Mobile Number"
                placeholder="Mobile Number"
                maxLength={10}
                value={profileDetails?.phoneNumber}
                handleChange={handleChange}
                readOnly={phone}
                mandatory={true}
                isInvalid={validationError.phoneNumber}
                required
              />
            </div>
          )}
        </div>

        {/* Row 3: Gender, Location */}
        <div className="col-md-6 mb-4">
          <div className="position-relative py-2">
            <Select
              selectedValue={profileDetails?.gender}
              options={["Male", "Female", "GenderFluid", "Other"]}
              optionValues={["Male", "Female", "Gender Fluid", "Others"]}
              labelClass=""
              label="Gender"
              name="gender"
              placeholder="Select"
              handleChange={(value) => handleSelectChange(value, "gender")}
              required={true}
              isInvalid={validationError.gender}
              mandatory={true}
            />
          </div>
        </div>

        <div className="col-md-6 mb-4">
          <div className="position-relative py-2">
            <Select
              selectedValue={profileDetails?.nationality}
              options={["Within India", "Outside India"]}
              optionValues={["withInIndia", "outSideIndia"]}
              labelClass=""
              label="Location"
              name="nationality"
              placeholder="Select"
              handleChange={(value) => handleSelectChange(value, "nationality")}
              required={true}
              isInvalid={validationError.nationality}
              mandatory={true}
            />
          </div>
        </div>

        {/* Row 4: Journal Type, Journal Name */}
        <div className="col-md-6 mb-4">
          <div className="position-relative py-2">
            <Select
              selectedValue={profileDetails?.journalType}
              options={["Mega Journal", "Society Journal"]}
              optionValues={["Mega Journal", "Society Journal"]}
              labelClass=""
              label="Journal Type"
              name="journalType"
              placeholder="Select"
              handleChange={(value) => handleSelectChange(value, "journalType")}
              required={true}
              isInvalid={validationError.journalType}
              mandatory={true}
            />
          </div>
        </div>

        <div className="col-md-6 mb-4">
          <div className="position-relative py-2">
            <Select
              selectedValue={profileDetails?.journalName}
              options={journalNameOptions}
              optionValues={journalNameOptions}
              labelClass=""
              label="Journal Name"
              name="journalName"
              placeholder={
                profileDetails?.journalType ? "Select" : "Select Journal Type first"
              }
              disabled={!profileDetails?.journalType}
              handleChange={(value) => handleSelectChange(value, "journalName")}
              required={true}
              isInvalid={validationError.journalName}
              mandatory={true}
            />
          </div>
        </div>
      </div>
      <div className="mandatory-footer text-start">
        <span>*</span> Mandatory
      </div>

      <FormModal
        className="static-modal remove-profile_modal"
        size="sm"
        modalHeading="Remove Profile Picture?"
        upperInformationText="Sure you want to remove your profile picture?"
        show={openRemoveImage}
        closebutton={true}
        handleClose={() => setOpenRemoveImage(false)}
        onSubmit={() => handleRemoveImageSubmit()}
        submitButtonTitle="Remove"
      >
        <></>
      </FormModal>

      <ProfileModel
        show={openImageUpload}
        onSubmit={handleImageSubmit}
        onRetake={onRetake}
        informationText="Please choose from the options below"
        modalHeading="Upload Profile Picture"
        retakebuttonTitle={uploadedImage ? "Select a different image" : "Retake"}
        onImgCapture={capture}
        submitButtonTitle="Upload"
        disabled={false}
        handleClose={() => handleImageModalClose()}
        openWebcam={openWebcam}
        webcamImage={webcamImage ? true : false}
        uploadedImage={uploadedImage ? true : false}
        SelectdifferentImage={() => hiddenFileInput.current.click()}
      >
        <>
          <div className="upload-area">
            {!openWebcam ? renderImage() : render()}
            {!openWebcam && (
              <span className={"flex-fill" + `${uploadedImage ? " noBgColor" : ""}`}>
                <div
                  className="profile-upload"
                  onClick={() => !uploadedImage && hiddenFileInput.current.click()}
                >
                  {uploadedImage ? (
                    <img src={uploadedImage} alt="#" className="user-img" />
                  ) : (
                    <Link to="#" className="link text-decoration-none">
                      <img src={upload} className="me-2" alt="upload" />
                      Choose File
                    </Link>
                  )}
                </div>
                <input type="file" hidden ref={hiddenFileInput} onChange={handleUploadImage} />
              </span>
            )}
          </div>
          <div className="label-error text-center">{formError?.profile}</div>
        </>
      </ProfileModel>
      <p className="text-center mt-4 footer-buttonBar">{buttonBar}</p>
    </div>
  );
}
PersonalDetailsSection.propTypes = {
  handleChangeRadioButton: PropTypes.func,
  handleUploadImage: PropTypes.func,
  profile: PropTypes.string,
  profileDetails: PropTypes.shape({
    fullName: PropTypes.string,
    phoneNumber: PropTypes.number,
    email: PropTypes.string,
    gender: PropTypes.string,
  }),
  hiddenFileInput: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]).isRequired,
  handleChange: PropTypes.func,
  openImageUpload: PropTypes.bool,
  setOpenImageUpload: PropTypes.func,
  handleImageSubmit: PropTypes.func,
  showDoLatterModal: PropTypes.bool,
  setShowDoLatterModal: PropTypes.func,
  uploadedImage: PropTypes.string,
  handleWebcam: PropTypes.func,
  setOpenWebcam: PropTypes.func,
  openWebcam: PropTypes.bool,
  webcamImage: PropTypes.string,
  capture: PropTypes.func,
  handleImageModalClose: PropTypes.func,
  handleDoItLatterModal: PropTypes.func,
  phone: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setFormError: PropTypes.func,
  formError: PropTypes.object,
};

PersonalDetailsSection.defaultProps = {
  handleChangeRadioButton: () => null,
  handleUploadImage: () => null,
  profileDetails: {},
  profile: "",
  gender: "",
  handleChange: () => null,
  openImageUpload: false,
  setOpenImageUpload: () => null,
  handleImageSubmit: () => null,
  showDoLatterModal: false,
  setShowDoLatterModal: () => null,
  uploadedImage: "",
  handleWebcam: () => null,
  setOpenWebcam: () => null,
  openWebcam: false,
  webcamImage: "",
  capture: () => null,
  handleImageModalClose: () => null,
  handleDoItLatterModal: () => null,
  phone: "",
  setFormError: () => null,
  formError: {},
};
export default PersonalDetailsSection;
